module.exports = __webpack_public_path__ + "static/img/client-9.9c73d089.png";